<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="账号"
          prop="advTitle"
        >
          <el-input
            v-model="searchForm.coupon_account"
            placeholder="账号"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
                label="公司名称"
                prop="company_id"
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.company_id"
                  placeholder="公司名称"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.id"
                    :label="item.company_name"
                    :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.is_receive"
                  placeholder="是否领取"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions3"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.is_user"
                  placeholder="是否使用"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
                  type="primary"
                  @click="handleExportFormSubmit"
          >
            <d2-icon name="share" /> 导出
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="账号"
      >
        <template slot-scope="scope">
          {{scope.row.coupon_account}}
        </template>
      </el-table-column>

      <el-table-column
              label="密码"
      >
        <template slot-scope="scope">
          {{scope.row.coupon_pwd}}
        </template>
      </el-table-column>

      <el-table-column
        label="公司名称"
        prop="company_name"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.company_name}}
        </template>
      </el-table-column>
      <el-table-column
        label="面值"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.amount}}
        </template>
      </el-table-column>
      <el-table-column
        label="领取时间"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.receive_times}}
        </template>
      </el-table-column>
      <el-table-column
              label="是否使用"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_user==0">
            未使用
          </div>
          <div v-else-if="scope.row.is_user==1">
           已使用
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as oneclassService from "@/api/sys/oneclass";
import util from '@/libs/util.js'
import editForm from "./editForm";
export default {
  name: "OneclassPage",
  components: { editForm },
  data() {
    return {
      searchForm: {
        coupon_account: "",
        is_user: "",
        is_receive: "",
        company_id: ""
      },
        is_agentid:"",
      loading: false,
      tableData: [],
      typeOptions: [],
      typeOptions2: [
        {
          value: "1",
          label: "已使用"
        },
        {
          value: "0",
          label: "未使用"
        }
      ],
      typeOptions3: [
        {
          value: "1",
          label: "已领取"
        },
        {
          value: "0",
          label: "未领取"
        }
      ],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
      editFormVisible: false
    };
  },
  mounted() {
      if(util.cookies.get('agentid')==null || util.cookies.get('agentid')==""){
          this.is_agentid="7080007";
      }else{
          this.is_agentid=util.cookies.get('agentid');
      }
    var formData2 = new FormData() // 声明一个FormData对象
    oneclassService.getCompanyid(formData2).then(data => {
      this.typeOptions=data;
    });
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          xt_id:util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        oneclassService.getYearCouponPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },

    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    handleExportFormSubmit() {
      window.location.href=encodeURI(process.env.VUE_APP_API+"/moblieapp/vouchertoExcel?coupon_account="+ this.searchForm.coupon_account+"&is_user="+this.searchForm.is_user+"&is_receive="+this.searchForm.is_receive+"&company_id="+this.searchForm.company_id);
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          oneclassService
          .delYearvouchers({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          oneclassService.delYearvoucher({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
